/**
 * @generated SignedSource<<e8576c57f4050623260776a58a357f00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleDataOperatorActivePayload",
    "kind": "LinkedField",
    "name": "toggleDataOperatorActive",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "configurationTaskMetrics",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workQueueActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workQueueMetrics",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleDataOperatorActiveTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToggleDataOperatorActiveTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "defd76e6810505fc4d2c42226da4ee16",
    "id": null,
    "metadata": {},
    "name": "ToggleDataOperatorActiveTaskMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleDataOperatorActiveTaskMutation(\n  $input: ToggleDataOperatorActiveInput!\n) {\n  toggleDataOperatorActive(input: $input) {\n    viewer {\n      configurationTaskMetrics\n    }\n    user {\n      id\n      workQueueActive\n      workQueueMetrics\n    }\n  }\n}\n"
  }
};
})();

node.hash = "21583b969d0f4e4760db98661c8bd553";

module.exports = node;
